/* Table of contents for long articles.
   ----------------------------------------------------------------
   Ghost has no {{toc}} helper, so this is built client-side from the rendered
   article. It is progressive: if the script never runs, the article is exactly
   as it was.

   Three things it deliberately handles:
     - the auto-appended AI disclaimer is an <h2 id="disclaimer"> on 71 posts and
       is not part of the argument, so it is excluded;
     - several published posts carry empty headings and duplicate or blank ids
       (<h2 id="">, <h2 id="-1">), so ids are repaired rather than trusted;
     - short pieces get nothing — a two-entry contents list is furniture. */
(function () {
    const article = document.querySelector('.post-template .gh-content');
    if (!article) return;

    const MIN_HEADINGS = 3;

    const headings = Array.from(article.querySelectorAll(':scope > h2'))
        .filter(function (h) {
            return h.id !== 'disclaimer' && h.textContent.trim().length > 0;
        });

    if (headings.length < MIN_HEADINGS) return;

    const slug = function (text) {
        return text.toLowerCase().trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '') || 'section';
    };

    const used = new Set();
    headings.forEach(function (h, i) {
        let id = (h.id || '').trim();
        if (!id || id === '-1' || used.has(id)) {
            id = slug(h.textContent);
            if (used.has(id)) id = id + '-' + (i + 1);
            h.id = id;
        }
        used.add(h.id);
    });

    const nav = document.createElement('aside');
    nav.className = 'crpg-toc';
    nav.setAttribute('aria-label', 'On this page');

    const heading = document.createElement('p');
    heading.className = 'crpg-toc-title';
    heading.textContent = 'On this page';
    nav.appendChild(heading);

    const list = document.createElement('ol');
    list.className = 'crpg-toc-list';
    headings.forEach(function (h) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        a.className = 'crpg-toc-link';
        li.appendChild(a);
        list.appendChild(li);
    });
    nav.appendChild(list);

    article.parentNode.insertBefore(nav, article);

    /* Mark the section currently in view. Guarded because IntersectionObserver
       is the only part of this that a browser might not have. */
    if (!('IntersectionObserver' in window)) return;

    const links = new Map();
    nav.querySelectorAll('.crpg-toc-link').forEach(function (a) {
        links.set(a.getAttribute('href').slice(1), a);
    });

    let active = null;
    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            const link = links.get(entry.target.id);
            if (!link || link === active) return;
            if (active) active.classList.remove('is-active');
            link.classList.add('is-active');
            active = link;
        });
    }, { rootMargin: '-80px 0px -70% 0px', threshold: 0 });

    headings.forEach(function (h) { observer.observe(h); });
})();
